import { render, staticRenderFns } from "./PageDay.vue?vue&type=template&id=b2223562"
import script from "./PageDay.vue?vue&type=script&lang=js"
export * from "./PageDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports